import { Component } from "react";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { clone, guid } from "../../../utils";
import DatePicker from "../../Input/DatePicker";

class FormDatePicker extends Component {
    state = {
        opened: false,
    };

    onDateChange(date) {
        let response = clone(this.props.question);
        let responseAnswer = response.response_answers[0];

        if (!responseAnswer)
            response.response_answers.push({
                answer: date,
                answer_id: this.props.answers[0].id,
                column_id: false,
                comment: "",
                comment_field: "",
                id: null,
                guid: guid(),
                response_id: response.id,
                value_choice: "",
                deleted: false,
            });

        responseAnswer = response.response_answers[0];
        responseAnswer.answer = date;
        this.props.responseValueChange(response);
        if (typeof this.props.save === "function") {
            this.props.save();
        }
        this.close();
    }

    onDateClick() {
        if (!this.state.opened && !this.props.inputProperties.disabled)
            this.open();
    }

    open() {
        if (!this.props.inputProperties.disabled)
            this.setState({ opened: true });
    }

    close() {
        this.setState({ opened: false });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        let hasValue =
            this.props.question &&
            this.props.question.response_answers &&
            this.props.question.response_answers.length > 0 &&
            this.props.question.response_answers[0].answer;

        return (
            <div
                className="full_size control-margin-top"
                onClick={this.onDateClick.bind(this)}
            >
                <DatePicker
                    {...this.props.inputProperties}
                    value={
                        hasValue
                            ? this.props.question.response_answers[0].answer
                            : null
                    }
                    invalidDateMessage="La date est invalide"
                    invalidLabel="La date est invalide"
                    cancelLabel="Annuler"
                    format="DD/MM/YYYY"
                    onOpen={this.open.bind(this)}
                    onClose={this.close.bind(this)}
                    open={this.state.opened}
                    className={
                        this.props.inputProperties.className +
                        " full_size " +
                        (this.props.inputProperties.disabled
                            ? "light-disabled"
                            : "")
                    }
                    onChange={this.onDateChange.bind(this)}
                />
            </div>
        );
    }
}

export default FormDatePicker;
